import { useEffect } from "react";
import { useAuth } from "./AuthContext";
import { setApiAuthState } from "../services/apiClient";

export function AuthBridge() {
  const { getAccessToken, deviceFingerprint, stepUpMfa, logout, setForbidden, setJitRequired } = useAuth();

  useEffect(() => {
    setApiAuthState({
      getAccessToken,
      deviceFingerprint,
      stepUpMfa,
      onUnauthorized: logout,
      onForbidden: () => setForbidden(true),
      onJitRequired: () => setJitRequired(true),
    });
  }, [getAccessToken, deviceFingerprint, stepUpMfa, logout, setForbidden, setJitRequired]);

  return null;
}
